export const ADD_REVIEW = 'ADD_REVIEW';
export const GET_REVIEW = 'GET_REVIEW';
export const GET_REVIEWS = 'GET_REVIEWS';
export const GET_REVIEWS_POPULAR = 'GET_REVIEWS_POPULAR';
export const DELETE_REVIEW = 'DELETE_REVIEW';
export const EDIT_REVIEW = 'EDIT_REVIEW';
export const SET_REVIEW_ID = 'SET_REVIEW_ID';
export const SORT_REVIEW = 'SORT_REVIEW';
export const FILTER_REVIEW_CATEGORY = 'FILTER_REVIEW_CATEGORY';
export const EDIT_USER_RATING_REVIEW = 'EDIT_USER_RATING_REVIEW';
export const SET_TAG = 'SET_TAG';
export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const SORT_CATEGORY = 'SORT_CATEGORY';
export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';
export const ADD_USER = 'ADD_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const SET_USER_LOCALE = 'SET_USER_LOCALE';
export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE';
export const SET_USER_THEME = 'SET_USER_THEME';
export const GET_TAGS = 'GET_TAGS';
export const ADD_TAG = 'ADD_TAG';
export const SET_TAG_COUNT = 'SET_TAG_COUNT';
export const GET_COMMENTS = 'GET_COMMENTS';
export const ADD_COMMENT = 'ADD_COMMENT';

